import React from 'react';
import CardTrainer from '../CardTrainer/CardTrainer';
import styles from './CardTrainerContainer.module.css';

const columns = [
  'Foto', 'Nombre', 'DNI', 'Email', 'Teléfono', 'Especialidad', 'Estado'
];

const CardTrainerContainer = ({ trainers }) => {
  if (!trainers.length) return <p>No hay entrenadores para mostrar.</p>;
  return (
    <div className={styles.tableContainer}>
      <div className={styles.headerRow}>
        {columns.map(col => (
          <div key={col} className={styles.headerCell}>{col}</div>
        ))}
      </div>
      {trainers.map(trainer => (
        <CardTrainer key={trainer.id} trainer={trainer} />
      ))}
    </div>
  );
};

export default CardTrainerContainer;